import { render, staticRenderFns } from "./EditorViewsDialog.vue?vue&type=template&id=13ae0274&scoped=true&"
import script from "./EditorViewsDialog.vue?vue&type=script&lang=js&"
export * from "./EditorViewsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditorViewsDialog.vue?vue&type=style&index=0&id=13ae0274&prod&scoped=true&lang=css&"
import style1 from "./EditorViewsDialog.vue?vue&type=style&index=1&id=13ae0274&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae0274",
  null
  
)

export default component.exports